// Notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'
export const SHOW_ERROR_NOTIFICATIONS = 'SHOW_ERROR_NOTIFICATIONS'
export const CLEAR_ALL_NOTIFICATIONS = 'CLEAR_ALL_NOTIFICATIONS'

// Workflows
export const ADD_WORKFLOW = 'ADD_WORKFLOW'
export const UPDATE_WORKFLOW = 'UPDATE_WORKFLOW'
// export const REMOVE_WORKFLOW = 'REMOVE_WORKFLOW'
// export const CLEAR_WORKFLOWS = 'CLEAR_WORKFLOWS'

// Config
export const MERGE_CONFIG = 'MERGE_CONFIG'

// History
// export const ADD_FRAGMENT = 'ADD_FRAGMENT'
// export const REMOVE_FRAGMENT = 'REMOVE_FRAGMENT'
// export const CLEAR_FRAGMENTS = 'REMOVE_FRAGMENTS'

// Dynamic workflow
export const ADD_DYNAMIC_WORKFLOW = 'ADD_DYNAMIC_WORKFLOW'
export const REMOVE_DYNAMIC_WORKFLOW = 'REMOVE_DYNAMIC_WORKFLOW'
export const CLEAR_ALL_DYNAMIC_WORKFLOWS = 'CLEAR_ALL_DYNAMIC_WORKFLOWS'

// Form
export const ADD_FORM = 'ADD_FORM'
export const REMOVE_FORM = 'REMOVE_FORM'
export const UPDATE_FORM = 'UPDATE_FORM'
export const SET_FORM_DATA = 'SET_FORM_DATA'
export const CLEAR_FORM_DATA = 'CLEAR_FORM_DATA'
export const REMOVE_ALL_FORMS = 'REMOVE_ALL_FORMS'
export const REMOVE_FORM_FIELD = 'REMOVE_FORM_FIELD'

// API
export const SET_API = 'SET_API'
export const SET_SKIN = 'SET_SKIN'

// TABLE
export const SET_PAGE = 'SET_PAGE'
export const SET_ROWS_PER_PAGE = 'SET_ROWS_PER_PAGE'
export const SORT_COLUMNS_BY = 'SORT_COLUMNS_BY'

// SKIN
export const UPDATE_SKIN = 'UPDATE_SKIN'

// NAVIGATION
export const SET_NAVIGATION = 'SET_NAVIGATION'



// WEBPACK FOOTER //
// ./src/vuex/mutation-type.js